import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FirebaseService } from '../service/firebase.service';
import { SharedService } from './shared.service';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  depthLevel: number = 0;
  currentDepthLevel: number = 0;

  observeDepthLevel: any = new BehaviorSubject(0);

  constructor(private _firebase: FirebaseService, private _shared: SharedService) { }



  getDepthLevel(tab) {
    tab.forEach((item) => {
      if (item.children != undefined && item.children.length > 0) {
        this.depthLevel++;
        this.getDepthLevel(item.children)
      }
    })
  }

  renameNode(name, id, tab) {

    /*return new Promise<any>((resolve, reject) => {

    })*/

    let loopThrough = function (e) {
      e.forEach((item) => {

        if (item.id == id) {

          if (item.displayName)
            item.displayName = name
          else
            item.name = name
          return;
        }

        if (item.children != undefined && item.children.length > 0) {
          loopThrough(item.children);
        }

      })
    }


    loopThrough(tab);

  }

  renameTranslationNode(data, id, tab) {
    let loopThrough = function (e) {
      e.forEach((item) => {

        if (item.id == id) {
          if (item.mediaOptions && item.mediaOptions.langArray) {
            item.mediaOptions.langArray = data
          }

          return;
        }

        if (item.children != undefined && item.children.length > 0) {
          loopThrough(item.children);
        }

      })
    }


    loopThrough(tab);
  }


  updateElement(tab, id, key, value) {
    let loopThrough = function (e) {
      e.forEach((item) => {

        if (item.id == id) {
          item[key] = value;
          return;
        }

        if (item.children != undefined && item.children.length > 0) {
          loopThrough(item.children);
        }
      })
    }


    loopThrough(tab);
  }


  getAllChildrenOfElement(tab, id) {
    let array = [];
    let found: boolean = false;
    let selectedPath: string = '';

    return new Promise<any>((resolve, reject) => {
      let loopThrough = function (e) {

        for (let item of e) {


          //  console.log(item.children.length )
          if (item.id == id) {
            found = true;
            selectedPath = `${item.path}/${item.name}`;

            //console.log(selectedPath)
          }
          if (found && item.id != id && item.path == selectedPath) {

            array.push(item);
          }
          if (item.children != undefined && item.children.length > 0) {
            //console.log("CHECK IN CHILD ELEMENT", item)
            loopThrough(item.children)
          }

        }

        /*e.forEach((item) => {

          if (item.id == id) {
            console.log("ITEM: ", item)
          }


          console.log(item)
        })*/
      }


      loopThrough(tab)

      resolve(array);
      //console.log(array)
    })


  }

  getAllNestedArrayElement(tab, id) {
    let array = [];

    let loopThrough = function (e) {
      e.forEach((item) => {

        if (item.id != id && item.type == 'folder')
          array.push(item);
        if (item.children != undefined && item.children.length > 0) {
          loopThrough(item.children);
        }
        //console.log(item)
      })
    }


    loopThrough(tab);
    return array;
    //console.log(array);
  }

  getNestedArrayElementWithoutChildren(tab, id) {
    let array = [];

    let loopThrough = function (e) {
      e.forEach((item) => {

        if (item.id != id && item.type == 'folder')
          array.push(item);
        if (item.children != undefined && item.children.length > 0 && item.id != id) {
          loopThrough(item.children);
        }
        //console.log(item)
      })
    }


    /* WORK ON TAB */
    console.log(tab, id)
    if (!this._firebase.user.assignedDevice || this._firebase.user.enableAllContent) {

      loopThrough(tab);
    }
    else if (this._firebase.user.assignedDevice) {

      loopThrough(this._shared.defaultFolder.children)

      array.unshift(this._shared.defaultFolder)
    }


    console.log(array)
    return array;
    //console.log(array);
  }

  deleteElementFromNestedArray(tab, id) {
    tab.forEach((item, index, object) => {
      let found = false;
      if (item.id == id) {
        object.splice(index, 1)
        //console.log(tab)

        found = true;
        //return tab
        // return tab
      }
      else if (item.children != undefined && item.children.length > 0 && !found) {

        if (item.id == id) {
          object.splice(index, 1)
          // return tab
        }
        else {
          this.observeDepthLevel.next(++this.currentDepthLevel);
          this.deleteElementFromNestedArray(item.children, id)
        }
      }
    })
  }


  isIterable(obj) {
    if (obj == null) {
      return false;
    }
    return typeof obj[Symbol.iterator] === 'function';
  }




  moveElement(tab, targetId, srcId) {
    let itemToMove;

    /* let loopThrough = (e) => {
       if (this.isIterable(e))
         for (let item of e) {
           if (item.id == srcId) {
             itemToMove = item;
             item = null;
           }
           else if (item.id == targetId) {
             item.children.push(itemToMove)
           }
           else if (item.children != undefined && item.children.length > 0)
             loopThrough(item.children)
         }
     }
 
     loopThrough(tab);*/

    let srcItem = this.getFolderFromId(tab, srcId);

    //console.log(srcItem)
    this.deleteElementFromNestedArray(tab, srcId);


    let loopThrough = (e) => {
      if (this.isIterable(e))
        for (let item of e) {
          if (item.id == targetId) {
            item.children.push(srcItem)
          }
          else if (item.children != undefined && item.children.length > 0)
            loopThrough(item.children)
        }
    }

    loopThrough(tab);


    //console.log(tab);
  }

  getFolderFromId(tab, id) {
    let res;

    let loopThrough = (e) => {
      if (this.isIterable(e))
        for (let item of e) {
          if (item.id == id) {
            res = item;
          }

          else if (item.children != undefined && item.children.length > 0)
            loopThrough(item.children)
        }
    }

    loopThrough(tab);
    return res;
  }

  getContentFromFolder(tab, id) {
    //console.log(this._firebase.selectedModuleData);
    //console.log(tab)
    return new Promise<any>((resolve, reject) => {

      let loopThrough = (e) => {
        if (this.isIterable(e))
          for (let item of e) {
            if (item.id == id) {
              //console.log(item)
              resolve(item.children);
            }

            else if (item.children != undefined && item.children.length > 0)
              loopThrough(item.children)
          }
      }


      loopThrough(tab);
    })

  }

  getRootContent() {
    //return this.
  }

  getElementFromNestedArray(tab, id): Promise<any> {

    return new Promise<any>((resolve, reject) => {
      this.getDepthLevel(tab);



      this.deleteElementFromNestedArray(tab, id);

      this.observeDepthLevel.subscribe((d) => {
        resolve(tab);
      })
      this.depthLevel = 0;
      this.currentDepthLevel = 0;
    })
  }


  cleanData(tab) {

    //console.log("BEFORE CLEAN:", JSON.parse(JSON.stringify(tab)))
    let loopThrough = (e) => {
      if (this.isIterable(e))
        for (let item of e) {
          if (item.mediaOptions) {
            //console.log(item)

            delete item.mediaOptions;
          }

          else if (item.children != undefined && item.children.length > 0)
            loopThrough(item.children)
        }
    }
    loopThrough(tab)
    //console.log("AFTER CLEAN", tab)
    return tab;
  }

  addFileToModuleData(tab, id, data) {
    //console.log(this._firebase.selectedModuleData);

    return new Promise<any>((resolve, reject) => {

      let loopThrough = (e) => {
        if (this.isIterable(e))
          for (let item of e) {
            if (item.id == id) {
              item.children.push(data);
              resolve(tab);
            }

            else if (item.children != undefined && item.children.length > 0)
              loopThrough(item.children)
          }
      }


      loopThrough(tab);
    })
  }

  replaceAllChildren(tab, id, children) {
    return new Promise<any>((resolve, reject) => {

      let loopThrough = (e) => {
        if (this.isIterable(e))
          for (let item of e) {
            if (item.id == id) {
              item.children = children;
              resolve(tab);
            }

            else if (item.children != undefined && item.children.length > 0)
              loopThrough(item.children)
          }
      }


      loopThrough(tab);
    })
  }


}
